<template>
  <div class="warp warp_enterprise" v-if="data">
    <Head></Head>
    <div class="modle_1" :style="'background: url('+data.img2+') center no-repeat;'">

      <div class="txt_box">
        <div class="t1">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription || data.seokeywords}}
        </div>
      </div>

      <ChildBan></ChildBan>
    </div>


    <div class="modle_2 cle">

      <div class="let fl" v-scroll-reveal>
        <img :src="data.list[0].img1" />

      </div>
      <div class="rit" v-scroll-reveal>

        <div class="text_box">

          <div class="t1">
            <span>{{data.list[0].title}}</span>{{data.list[0].tags}}
          </div>
          <div class="t2">
            {{data.list[0].introduce}}
          </div>

          <div class="t3">

            {{data.list[0].seokeywords}}
          </div>

          <div class="t4">
            {{data.list[0].seodescription}}
          </div>

        </div>

      </div>

    </div>


    <div class="modle_3 cle">

      <div class="text " v-scroll-reveal>
        <div class="t1">
          {{data.list[1].title}}
        </div>
        <div class="t2">
          {{data.list[1].tags}}
        </div>

        <div class="msg" v-scroll-reveal v-html="data.list[1].introduce">

        </div>
      </div>


    </div>

    <div class="modle_4" v-scroll-reveal style="width: 100%;">
      <img :src="data.list[1].img1" style="width: 100%;" />
    </div>


    <div class="modle_3 modle_5">
      <div class="text " v-scroll-reveal>
        <div class="t1">
          {{data.list[2].title}}
        </div>
        <div class="t2" v-scroll-reveal>
          {{data.list[2].tags}}
        </div>
        <div class="msg" v-scroll-reveal v-html="data.list[2].introduce">
          
        </div>
      </div>
    </div>

    <div class="modle_4" v-scroll-reveal style="width: 100%;">
      <img :src="data.list[2].img1" style="width: 100%;" />
    </div>

    <div class="modle_3">
      <div class="text ">
        <div class="t1" v-scroll-reveal>
          {{data.list[3].title}}
        </div>
        <div class="t2" v-scroll-reveal>
          {{data.list[3].tags}}
        </div>
        <div class="msg" v-scroll-reveal>
          {{data.list[3].introduce}}
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import {
    postIntroduceAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'
  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        data: null
      }
    },
    methods: {
      //获取公司介绍
      getList() {
        var that = this;
        postIntroduceAPI().then(function(res) {
          console.log(res);
          that.data = res.data.data;
        }).catch(function(err) {
          console.log(err);
        })
      },
    },
    mounted() {
      this.getList();
    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }

  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .modle_2 {

    position: relative;

    .let {
      width: 44%;


    }

    .rit {
      position: absolute;
      width: 55%;
      right: 0px;
      height: 100%;
      top: 0px;

      .text_box {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding-left: 8%;
        padding-right: 5%;

        .t1 {
          font-weight: bold;
          font-size: 45px;
          text-align: left;

          span {
            color: #282828;
            font-size: 107px;


          }
        }

        .t2 {
          font-size: 28px;
          color: #282828;
          text-align: left;
          margin-bottom: 60px;
        }

        .t3 {
          text-align: left;
          position: relative;
          padding-bottom: 40px;
          position: relative;
          margin-bottom: 40px;
        }

        .t3::before {
          content: '';
          position: absolute;
          width: 80px;
          height: 1px;
          background: #282828;
          display: block;
          bottom: 0px;
          left: 0px;
        }

        .t4 {
          text-align: left;
          font-size: 18px;
          color: #282828;
          line-height: 34px;
          font-family: Arial, Helvetica, sans-serif;
        }
      }
    }
  }


  .modle_3 {
    padding: 218px 85px 240px;

    .text {
      color: #000000;
      text-align: right;
      font-weight: bold;

      .t1 {
        font-size: 270px;
        line-height: 210px;
      }

      .t2 {
        font-size: 180px;
      }

      .msg {

        color: #000000;
        font-size: 49px;
        font-weight: normal;
        margin-top: 85px;

      }
    }
  }

  .modle_4 {
    background: #969696;
    width: 100%;
  }

  .modle_5 {
    .text {
      text-align: left;

      .msg {
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/enterprise/enterprise.vue